module.exports = __webpack_public_path__ + "static/img/shop.ddb9d474.png";